const stati = [
  { kurz: 'A', titel: 'aktiv' },
  { kurz: 'E', titel: 'erledigt' },
  { kurz: 'P', titel: 'gestoppt' },
];

export default stati;

export function getStatusTitle(kurz) {
  if (kurz === '') return stati.find((e) => e.kurz === 'A')?.titel || '';
  return stati.find((e) => e.kurz === kurz)?.titel || '';
}
